import { render, staticRenderFns } from "./updateStatus.vue?vue&type=template&id=1bfa303c&"
import script from "./updateStatus.vue?vue&type=script&lang=ts&"
export * from "./updateStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports